import { TRACE_STORE_NAME } from '@/creditflowresearch/application/Trace/constants';
import SharedFooter from '@/creditflowresearch/ui/common/components/organisms/Filters/FiltersPanel/Footer';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { useFiltersContext } from '@framework/ui/Organisms/Filters/FiltersContext';

const SharedFooterContainer = (props) => {
  const { getFilters } = useFiltersContext();
  const filters = getFilters(TRACE_STORE_NAME);
  const { filtersPayload, appliedFilters, initialFilters } = useTraceFiltersContext();

  return (
    <SharedFooter
      { ...props }
      filtersPayload={ filtersPayload }
      appliedFilters={ appliedFilters }
      initialFilters={ initialFilters }
      filters={ filters }
    />
  );
};

export default SharedFooterContainer;
